<script>
import Main from './main.vue';

export default Main.extend({
  computed: {
    seriesData() {
      return this.graphicsData.map((line, ind) => {
        const sourceLang = this.$store.state.dictionaries.languages.find((el) => el.ID === line.SourceLanguageId);
        const targetLang = this.$store.state.dictionaries.languages.find((el) => el.ID === line.TargetLanguageId);
        const data = line.KpiData[0];
        return {
          name: `${sourceLang.LanguageISOCode}-${sourceLang.CountryISOCode} > ${targetLang.LanguageISOCode}-${targetLang.CountryISOCode}`,
          data: [{
            x: ind,
            y: data.Rating,
            qa: {
              score: data.Rating,
              level: data.QualityLevel,
            },
            reports: data.ErrorItemStatisticsData.Total,
          }],
        };
      });
    },
  },
});
</script>
